import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "../../css/ShowRoom.css";

const ExternalSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);
  const [clickDelay, setClickDelay] = useState(null); // Track the timeout delay
  const sliderRef = useRef(null); // Reference to the slider instance
  const sliderContainerRef = useRef(null); // Reference to the slider container

  const isMouseInside = useRef(false); // Track if the mouse is inside the slider


  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: true,
    focusOnSelect: true,

    beforeChange: (current, next) => {
      setPrevIndex(current);
      setCurrentIndex(next);
    },

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Determine the number of levels based on the current path
  const getBasePath = () => {
    const depth = window.location.pathname.split("/").length - 1;
    return "../".repeat(depth - 1); // Adjust `-1` based on your specific project structure
  };

  const basePath = getBasePath();

  const slides = [
    {
      id: 1,
      title: "COASTAL RESIDENCE",
      description:
        "A stunning modern coastal exterior design featuring natural materials and a seamless connection with the surrounding environment",
      image: `${basePath}Images/exteriorimages/1.png`,
      link: "/exterior-design/coastal-contemporary",
    },
    {
      id: 2,
      title: "MODERN HARMONY",
      description:
        "A blend of contemporary and traditional design elements, emphasizing comfort and luxury, ideal for sophisticated city living.",
      image: `${basePath}Images/exteriorimages/2.jpg`,
      link: "/exterior-design/modern-harmony",
    },
    {
      id: 3,
      title: "LOCA RESIDENCES",
      description:
        "A residence design that emphasizes innovation and collaboration, with open spaces and modern features for luxurious living.",
      image: `${basePath}Images/exteriorimages/3.jpg`,
      link: "/exterior-design/loca-residences",
    },
    {
      id: 4,
      title: "VILLA FACADE",
      description:
        "A villa facade, incorporating elegance, functionality, and cultural harmony for a timeless architectural statement.",
      image: `${basePath}Images/exteriorimages/4.jpg`,
      link: "/exterior-design/villa-facade",
    },
    {
      id: 5,
      title: "DYNAMIC URBAN",
      description:
        "A bold and innovative urban exterior design that blends modern aesthetics with functionality, designed for a vibrant, urban lifestyle.",
      image: `${basePath}Images/exteriorimages/5.jpg`,
      link: "/exterior-design/dynamic-urban",
    },
    {
      id: 6,
      title: "PRIVATE VILLA",
      description:
        "An exclusive private villa design, combining modern architecture with luxurious living spaces to create a sophisticated private retreat.",
      image: `${basePath}Images/exteriorimages/6.jpg`,
      link: "/exterior-design/private-villa",
    },
  ];
  

  // Handle the smooth transition timing for description
  useEffect(() => {
    if (prevIndex !== null) {
      const timeout = setTimeout(() => {
        setPrevIndex(null); // Reset the previous index after transition
      }, 800); // Matches the transition duration in CSS (0.8s)
      return () => clearTimeout(timeout);
    }
  }, [prevIndex]);

  const handleMouseDown = () => {
    // Set a delay before triggering the click to prevent accidental clicks during dragging
    setClickDelay(
      setTimeout(() => {
        setClickDelay(null); // Reset the delay after the timeout
      }, 200)
    ); // Delay for 200ms, you can adjust as needed
  };

  const handleClick = (link) => {
    if (clickDelay) {
      if (link) {
        window.location.href = link; // Navigate to the link
      }
    }
  };

      // Scroll and arrow key navigation
      useEffect(() => {
       
      
        const handleWheel = (event) => {
          if (isMouseInside.current && sliderRef.current) {
            event.preventDefault(); // Prevent page scroll
            if (event.deltaY > 0) {
              sliderRef.current.slickNext();
            } else {
              sliderRef.current.slickPrev();
            }
          }
        };
    
            // Only add the event listener when mouse is inside slider container
            const sliderContainer = sliderContainerRef.current;
            if (sliderContainer) {
              sliderContainer.addEventListener("wheel", handleWheel, { passive: false });
            }
        
      
    
        // Function to handle arrow key navigation
        const handleKeyDown = (event) => {
          if (isMouseInside.current && sliderRef.current) {
            if (event.key === "ArrowRight") {
              sliderRef.current.slickNext(); // Right arrow key moves to next slide
            } else if (event.key === "ArrowLeft") {
              sliderRef.current.slickPrev(); // Left arrow key moves to previous slide
            }
          }
        };
    
        // Attach event listeners to the window
        if (sliderContainer) {
          window.addEventListener("wheel", handleWheel, { passive: false });
          window.addEventListener("keydown", handleKeyDown, { passive: false });
        }
    
        // Cleanup listeners on component unmount
        return () => {
          window.removeEventListener("wheel", handleWheel);
          window.removeEventListener("keydown", handleKeyDown);
        };
      }, []); // Runs only once when the component mounts
    
      // Optional: Automatically focus the slider container on load
      useEffect(() => {
        if (sliderRef.current) {
          sliderRef.current.innerSlider.list.focus();
        }
      }, []);

  return (
    <>
    <div className="slider-container"
       ref={sliderContainerRef}
       onMouseEnter={() => (isMouseInside.current = true)}
       onMouseLeave={() => (isMouseInside.current = false)}
    >
      {/* Image Container */}
      <div className="image-container">
        {slides.map((slide, index) => {
          let className = "main-image";
          if (index === currentIndex) {
            className += " active";
          } else if (index === prevIndex) {
            className += " outgoing";
          }

          return (
            <img
              key={slide.id}
              src={slide.image}
              alt={slide.title}
              className={`${className} ${
                index === currentIndex && prevIndex !== null ? "incoming" : ""
              }`}
              style={{
                height: "100%",
                width: "100%",
                backgroundSize: "cover",
                objectFit: "cover",
              }}
            />
          );
        })}
      </div>

      {/* Description text in a div */}
      <div
        className={`description-container ${
          prevIndex !== null ? "outgoing-text" : ""
        } ${currentIndex !== prevIndex ? "incoming-text" : ""} ${
          currentIndex === prevIndex ? "active-text" : ""
        }`}
      >
        <p className="description-text">{slides[currentIndex].description}</p>
      </div>

      {/* Titles Slider */}
      <Slider ref={sliderRef} {...sliderSettings} className="slider">
        {slides.map((slide, index) => (
          <div key={slide.id} className="slide">
            <div
              className={`slide-title ${
                index === currentIndex ? "active-title" : ""
              }`}
              onMouseDown={handleMouseDown} // Start the delay on mouse down
              // Handle click after delay
              style={{
                fontSize: "24px", // Bigger font
                fontWeight: "bold",
                textAlign: "center",
                cursor: slide.link ? "pointer" : "default", // Show pointer if navigable
              }}
            >
              <p
                onClick={() => handleClick(slide.link)}
                style={{
                  fontSize: "50px",
                }}
              >
                {slide.title}
              </p>{" "}
              {/* Wrap title with <p> tag */}
            </div>
          </div>
        ))}
      </Slider>
    </div>
     <div className="slides-list">
     {slides.map((slide) => (
       <div
         key={slide.id}
         className="list-item"
         onClick={() => window.location.href = slide.link}
       >
         {slide.title}
       </div>
     ))}
   </div>
  </>
  );
};

export default ExternalSlider;
